"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RejectionType = void 0;
// Re-export from @daytrip/legacy-enums
var legacy_enums_1 = require("@daytrip/legacy-enums");
Object.defineProperty(exports, "RejectionType", { enumerable: true, get: function () { return legacy_enums_1.RejectionType; } });
//# sourceMappingURL=RejectionType.js.map